export default function footer() {
  return `
  <footer class="footer">
    <div class="footer__contain">
            <p class="footer__list"> &copy; 2022 | All Rights Reserved |&nbsp;</p>  
            <p class="footer__developers" >Developed with 
            <svg class="footer__img" width="14" height="13" viewbox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg"">
            <path
            d="M7 12.88L6.02 11.9C2.38 8.68 0 6.51 0 3.85C0 1.68 1.68 0 3.85 0C5.04 0 6.23 0.56 7 1.47C7.77 0.56 8.96 0 10.15 0C12.32 0 14 1.68 14 3.85C14 6.51 11.62 8.68 7.98 11.9L7 12.88Z"
            fill="#FF6B08"
          />
          </svg>
             by &nbsp; <a class="footer__link" href="#team"> GoIT Students </a> 
            </p>         
    </div>
    </footer>
`;
}